module.exports = function() {
  return new Worker(__webpack_public_path__ + "6cb38637b48edfa3feea.worker.js");
};